import {Axios} from "api";
import {redirectToLogin} from "common/redirect";
import {isApp} from "common/utils";
import {useContext, useEffect, useState} from "react";
import PushContext, {PUSH_AGREEMENT_DAY_AD, PUSH_AGREEMENT_NIGHT_AD} from "context/PushContext";
import ModalContext from "context/ModalContext";
import UserContext from "context/AuthContext";
import {useRouter} from "next/router";
import {newCustomConfirm} from "common/newCustomConfirm";
import {toast} from "react-toastify";
import {TOAST_INFORMATION_PUSH_AGREEMENT} from "components/modal/PushAgreementModal";


const useBulkNotiSubscription = (topicKeys, contextName, pushType = PUSH_AGREEMENT_DAY_AD) => {

    const router = useRouter();
    const pushContext = useContext(PushContext);
    const userContext = useContext(UserContext);
    const user = userContext.user;

    const {openAppInstallModal} = useContext(ModalContext);

    const [isRequested, setIsRequested] = useState(null);

    const isPushOn = pushContext.isDevicePushOn
        && (
            (pushType === PUSH_AGREEMENT_NIGHT_AD && pushContext.pushAgreementInfo.isNightAdAgreed)
            || (pushType ===  PUSH_AGREEMENT_DAY_AD && pushContext.pushAgreementInfo.isAdAgreed)
            || (pushType ===  TOAST_INFORMATION_PUSH_AGREEMENT && pushContext.pushAgreementInfo.isInformationAgreed)
        );

    useEffect(() => {
        if (isPushOn && isRequested) {
            _toggle();
        }
    }, [isPushOn, isRequested]);

    const _toggle = async () => {
        try {
            const res = await Axios.post('v1/noti/bulk-toggle-subscription/', {
                targets: topicKeys.map(topicKey => ({
                    type: 'custom_topic',
                    noti_key: topicKey,
                })),
            });
            if (res.status < 400) {
                toast.info(
                    res.data.is_active ? '알림이 설정되었어요' : '알림이 해제되었어요',
                )
                setIsRequested(null);
            } else if (res.status === 401) {
                redirectToLogin(router, true);
            } else {
                alert('오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
            }
        } catch (e) {
            alert('오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
            console.log(e)
        }
    }

    const toggleSubscription = async () => {
        const inApp = isApp();
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'NotiSubscriptionToggle',
            {
                notiType: 'custom_topic',
                notiKey: topicKeys[0],
                isPushOn,
                contextName
            }
        );
        if (!user) {
            if (!inApp) {
                openAppInstallModal();
                return;
            }
            redirectToLogin(router, true);
            return;
        }

        if (isPushOn) {
            await _toggle();
            return;
        }

        if (!inApp) {
            openAppInstallModal();
        } else {
            if (isPushOn) {
                await _toggle();
            } else {
                newCustomConfirm(
                    '알림을 받아보시겠어요?',
                    null,
                    '좋아요', '다음에요',
                    () => {
                        typeof mixpanel !== 'undefined' && mixpanel.track(
                            'NotiSubscriptionToggleAgree',
                            {
                                contextName,
                            }
                        );
                        setIsRequested(true);
                        pushContext.sendPushAgreementRequest({isDayAgree: true});
                    },
                    () => {
                        typeof mixpanel !== 'undefined' && mixpanel.track(
                            'NotiSubscriptionToggleDisagree',
                            {
                                contextName,
                            }
                        );
                    }
                );
            }
        }
    };

    return {toggleSubscription}

};

export default useBulkNotiSubscription;
